import request from '@/utils/request'

export function projectItems (params) {
  return request({
    url: '/amrep/project/items',
    method: 'get',
    params
  })
}

export function projectDelete (data) {
  return request({
    url: '/amrep/project/delete/' + data.id,
    method: 'delete'
  })
}

export function projectDetails (data) {
  return request({
    url: '/amrep/project/details/' + data.id,
    method: 'get',
    params: {
      page: data.page,
      size: data.size
    }
  })
}

export function projectCreate (data) {
  return request({
    url: '/amrep/project/create',
    method: 'post',
    data
  })
}

export function projectCreateEmp (data) {
  return request({
    url: '/amrep/project/createEmp',
    method: 'post',
    data
  })
}

export function projectDeleteEmp (data) {
  return request({
    url: '/amrep/project/deleteEmp',
    method: 'post',
    data
  })
}

export function projectEmpRules (data) {
  return request({
    url: '/amrep/project/empRules',
    method: 'put',
    data
  })
}

export function projectRules (data) {
  return request({
    url: '/amrep/project/projectRules',
    method: 'put',
    data
  })
}



// WEBPACK FOOTER //
// ./src/api/project.js